// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NOTE: many of these constants have been duplicated in cssConstants.tsx */
/* Colours for Grid*/
/* Colours for Check statuses*/
/* Other colours */
/* black/grays/whites */
/* Colours for Data capture page*/
/* borders */
/* Dimensions*/
/* z-indexes */
/* Media queries */
/* Font Size */
/* Font Family */
/* Font Style */
@media (max-width: 846px) {
  .dataCapturePage .formLayout.k-form .nameChangeDocument {
    width: 100%;
  }
  .dataCapturePage .formLayout.k-form .nameChangeDocument .fileUploadField {
    max-width: 288px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/common/dataCapture/NameChangeDocuments.less"],"names":[],"mappings":"AAAA,2EAA2E;AAC3E,oBAAoB;AACpB,8BAA8B;AAC9B,kBAAkB;AAClB,uBAAuB;AACvB,iCAAiC;AACjC,YAAY;AACZ,cAAc;AACd,cAAc;AACd,kBAAkB;AAClB,cAAc;AACd,gBAAgB;AAChB,eAAe;AATd;EAAA;IACC,WAAA;EAYA;EAbD;IAIE,gBAAA;EAYD;AACF","sourcesContent":["@import '../../constants.less';\n\n.dataCapturePage .formLayout.k-form .nameChangeDocument {\n\t@media (max-width: @dataCaptureTwoColumnFieldsPageMinWidth) {\n\t\twidth: 100%;\n\n\t\t.fileUploadField {\n\t\t\tmax-width: @inputWidth;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
